import { DateServiceI } from '@pulse/common';
import { PulseEnvironment } from '../globals';

export class DateService extends DateServiceI {
    readonly hrtTimeOrigin: number;

    constructor(private env: PulseEnvironment) {
        super();
        const now = this.now();
        const hrt = this.hrt();

        const timeOrigin = env.win.performance.timeOrigin;

        this.hrtTimeOrigin = timeOrigin ?? now - hrt;
    }

    now(): number {
        return this.env.win.Date.now();
    }
    hrtTime(): number {
        return this.hrtTimeOrigin + this.env.win.performance.now();
    }
    hrt(): number {
        return this.env.win.performance.now();
    }
    timezoneOffset(): number | undefined {
        const d = new this.env.win.Date();

        return d.getTimezoneOffset && d.getTimezoneOffset();
    }
}
